import { isDefined } from '@sgme/fp';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import {
  useAlgoSetIsModifyingField,
  useAlgoTileId,
  useValidateAlgo,
} from '@/App/tiles/orders/AlgoOrders/AlgoContext.tsx';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { SgNumberInput } from '@/components/sg-design-system/components/input/SgNumberInput';
import { OmsFieldErrorWrapper } from '@/components/ui/OmsFieldErrorWrapper.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectAlgoErrors, selectAlgoLimitPrice } from '@/store/orders/algoOrders/selectors.ts';
import { useDebounce } from '@/utils/hooks/debounce.ts';

export const AlgoLimitPrice = () => {
  const tileId = useAlgoTileId();
  const setIsModifyingField = useAlgoSetIsModifyingField();
  const track = useTrackEvent();

  const value = useAppSelector((state) => selectAlgoLimitPrice(state, tileId));
  const errors = useAppSelector((state) => selectAlgoErrors(state, tileId));

  const validateAlgo = useValidateAlgo();

  const handleLimitPriceChange = useDebounce((newValue: number | undefined) => {
    track('Order action', 'No worse than changed');
    validateAlgo({
      limitPrice: newValue,
    });
  });

  const limitPriceError = errors?.limitPrice;

  return (
    <OrderRow labelId="order.fields.NoWorseThan">
      <OmsFieldErrorWrapper errors={limitPriceError}>
        <SgNumberInput
          valuePosition="start"
          value={value}
          maxDecimals={9}
          selectAllOnFocus
          onChange={handleLimitPriceChange}
          onFocus={() => setIsModifyingField(true)}
          onBlur={() => setIsModifyingField(false)}
          size="sm"
          data-e2e="no-worse-than"
          state={isDefined(limitPriceError) ? 'invalid' : undefined}
        />
      </OmsFieldErrorWrapper>
    </OrderRow>
  );
};
